import React from 'react'
import { string, object } from 'prop-types'
import EventLatestCTA from '@/component/Primitive/EventLatestCTA/EventLatestCTA'

const EventLatestCTAWidget = ({
  event,
  pageData,
  backgroundURL,
  textOverride,
  videoId
}) => {
  if (!event?.startDate) {
    return <></>
  }

  return (
    <EventLatestCTA
      event={event}
      pageData={pageData}
      backgroundURL={backgroundURL}
      textOverride={textOverride}
      videoId={videoId}
    />
  )
}

EventLatestCTAWidget.propTypes = {
  event: object,
  pageData: object,
  backgroundURL: string,
  textOverride: string,
  videoId: string
}

export default EventLatestCTAWidget
